import { render, staticRenderFns } from "./amount-flow-dialog.vue?vue&type=template&id=0a868a83&scoped=true&"
import script from "./amount-flow-dialog.vue?vue&type=script&lang=js&"
export * from "./amount-flow-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a868a83",
  null
  
)

export default component.exports